<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <p class="IncrementalData-supportingText">
        {{ $lang.diversityQuestions.explainer }}
        <br>
        <a
          target="_blank"
          href="/blog/privacy-policy/"
        >{{ $lang.diversityQuestions.privacyPolicy }}</a>
      </p>
      <div class="IncrementalData-question">
        <div class="Form-field ParentProfesion-modal-variant">
          <label
            for="profession+0"
            class="Form-label font-heavy"
          >What was the occupation of your main household earner when you were aged 14? (if you're younger than 14, please leave blank)</label>
          <div
            v-if="professionSelection"
            class="Tag Tag--blue Tag--small"
          >
            {{ professionSelection }}
          </div>
          <profession-selection-modal
            :parent-professions="parentProfessions"
            @parent-profession-selection="handleSelection"
          />
          <error-messages
            :errors="[validateStatus({ field: v$.fields.parent_profession, serverKey: 'parentProfession', label: `Parent's Profession` })][0]['errors']"
            :manual-validate="validateAll"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rmpRadio from '@/components/form/radio-button';
import errorMessages from '@/components/form/partials/error-message.vue';
import useVuelidate from '@vuelidate/core';
import ProfessionSelectionModal from '../modals/profession-selection-modal.vue';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {

  components: {
    ProfessionSelectionModal,
    rmpRadio,
    errorMessages,
  },
  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        parent_profession: null,
      },
      fieldName: 'parent_profession',
    };
  },
  computed: {
    ...mapState('entities', {
      parentProfessions: (state) => state.parentProfessions,
    }),
    updatePayload() {
      return this.fields;
    },
    professionSelection() {
      const profession = this.parentProfessions.find((item) => item.value === this.fields.parent_profession);
      return profession ? profession.text : null;
    },
  },
  mounted() {
    this.getParentProfessions();
  },
  methods: {
    ...mapActions('entities', [
      'getParentProfessions',
    ]),
    handleSelection(profession) {
      this.fields = { ...this.fields, parent_profession: profession };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../scss/components/diversity-questions/questions.scss";
</style>
